import { api } from "./apiServices";

const handleResponse = (response) => {
  let data = response.data;
  if (response.data.code == 6) {
    localStorage.removeItem("token");
    window.location.href = "/"
  }
  return data;
};

export const getNotifications = (token) => api(token).get("/admin/notifications").then(handleResponse);
export const markNotificationAsRead = (token, id) => api(token).put("/admin/notifications/" + id + "/read").then(handleResponse);
export const deleteNotification = (token, id) => api(token).delete("/admin/notifications/" + id).then(handleResponse);
export const clearAllNotifications = (token) => api(token).delete("/admin/notifications").then(handleResponse);
